import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { durationStringToMinutes, Group } from '@vendasta/meetings';
import { BookMeNowStoreService } from '../book-me-now-store.service';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { NavigationService } from '../navigation.service';

@Component({
  selector: 'app-group-selection-page',
  templateUrl: './group-selection-page.component.html',
  styleUrls: ['./group-selection-page.component.scss'],
  standalone: false,
})
export class GroupSelectionPageComponent implements OnInit {
  loadingForEnoughTime$: Observable<boolean>;
  group$: Observable<Group>;
  hideTitleText$: Observable<boolean>;
  constructor(
    public readonly bookMeNowStoreService: BookMeNowStoreService,
    private readonly route: ActivatedRoute,
    private router: Router,
    public navigationService: NavigationService
  ) {}

  ngOnInit(): void {
    const currentPath = this.router.url;
    this.bookMeNowStoreService.storeInitialPath(currentPath);
    const groupId = this.route.snapshot.params.groupId;
    const groupSlug = this.route.snapshot.params.groupSlug;

    if (groupId) {
      this.group$ = this.bookMeNowStoreService
        .loadGroup({
          groupId,
          groupSlug,
        })
        .pipe(
          catchError(() => {
            this.bookMeNowStoreService.setErrorDisplay('slug-mismatch-error');
            return of(null);
          })
        );
    } else {
      this.group$ = of(undefined);
    }

    this.hideTitleText$ = this.route.queryParams.pipe(
      map((params) => params?.hide_header === 'true')
    );
  }

  durationMinutes(duration: string): number {
    return durationStringToMinutes({ duration });
  }
}
